import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from "../../assets/close.svg";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { Buttons } from "components/MessageForm/styles";
import { Input } from "components/Form/Input";
import { useAddAgentAbsence } from "hooks/mutations/useAddAgentAbsence";
import { useSupportAgents } from "hooks/fetch/useSupportAgents";
import { SelectField, CheckboxRow } from "./styles";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  categoryId: string;
};

export function AddAbsenceModal({ isOpen, onRequestClose, categoryId }: Props) {
  const { handleSubmit, register, control, reset, formState: { isSubmitting } } = useForm<FieldValues>({
    defaultValues: {
      user_id: '',
      reason: '',
      starts_at: '',
      ends_at: '',
      auto_reactivate: true,
    },
  });

  const addAbsence = useAddAgentAbsence();
  const { data: agents } = useSupportAgents(categoryId);

  function handleClose() {
    reset();
    onRequestClose();
  }

  async function handleSubmitForm({ user_id, reason, starts_at, ends_at, auto_reactivate }: any) {
    await addAbsence.mutateAsync({
      user_id,
      reason: reason || undefined,
      starts_at,
      ends_at,
      auto_reactivate: Boolean(auto_reactivate),
    });
    handleClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <button type="button" onClick={handleClose} className="react-modal-close">
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Cadastrar ausência</ModalTitle>
        <Form onSubmit={handleSubmit(handleSubmitForm as SubmitHandler<FieldValues>)}>
          <SelectField id="user_id" {...register('user_id', { required: true })}>
            <option value="">Selecione um atendente...</option>
            {(agents ?? []).map(agent => (
              <option key={agent.user_id} value={agent.user_id}>{agent.user?.name ?? agent.user_id}</option>
            ))}
          </SelectField>

          <InputGroup>
            <Input
              control={control}
              type="text"
              name="reason"
              id="reason"
              label="Motivo (opcional)"
              maxLength={255}
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Input
              control={control}
              type="datetime-local"
              name="starts_at"
              id="starts_at"
              label="Início (data e hora)"
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Input
              control={control}
              type="datetime-local"
              name="ends_at"
              id="ends_at"
              label="Retorno (data e hora)"
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <CheckboxRow>
              <input type="checkbox" id="auto_reactivate" {...register('auto_reactivate')} defaultChecked />
              <label htmlFor="auto_reactivate">Reativar automaticamente ao fim do período</label>
            </CheckboxRow>
          </InputGroup>

          <InputGroup>
            <Buttons>
              <Button type="submit" fullwidth disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Cadastrar'}
              </Button>
              <Button type="button" onClick={handleClose}>Cancelar</Button>
            </Buttons>
          </InputGroup>
        </Form>
      </div>
    </Modal>
  );
}
